import { always, assoc, dissoc } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

// tag initial state
export const INITIAL_STATE = {
  isFetching: true,
  current: null,
  isFetchingArticles: true,
  articlePages: {},
  limit: 24,
  error: null,
}

export const FETCH = 'tag/FETCH'
export const RECEIVED = 'tag/RECEIVED'
export const FETCH_ARTICLE_PAGE = 'tag/FETCH_ARTICLE_PAGE'
export const RECEIVED_ARTICLE_PAGE = 'tag/RECEIVED_ARTICLE_PAGE'
export const REMOVE_ARTICLE_PAGE = 'tag/REMOVE_ARTICLE_PAGE'
export const ERROR = 'tag/ERROR'
export const CLEAN = 'tag/CLEAN'

// fetch :: () -> Action.FETCH
export const fetch = always({ type: FETCH })

// received :: Tag -> Action.RECEIVED
export const received = current => ({
  type: RECEIVED,
  current,
})

// fetchArticlePage :: Number-> Action.FETCH_ARTICLE_PAGE
export const fetchArticlePage = page => ({
  type: FETCH_ARTICLE_PAGE,
  page,
})

// removeArticlePage :: Number -> Action.REMOVE_ARTICLE_PAGE
export const removeArticlePage = page => ({
  type: REMOVE_ARTICLE_PAGE,
  page,
})

// receivedArticlePage :: (Number, Number, Number, Number, [article]) -> Action.RECEIVED_ARTICLE_PAGE
export const receivedArticlePage = (page, totalPages, scrollHeight, scrollTop, articles = []) => ({
  type: RECEIVED_ARTICLE_PAGE,
  page,
  totalPages,
  scrollHeight,
  scrollTop,
  articles,
})

// error :: Error -> Action
export const error = error => ({
  type: ERROR,
  error,
})

// clean :: () -> Action.CLEAN
export const clean = always({ type: CLEAN })

export default createReducer(INITIAL_STATE, {
  [FETCH]: () => ({
    ...INITIAL_STATE,
    error: null,
  }),
  [RECEIVED]: (state, { current }) => ({
    ...state,
    isFetching: false,
    error: null,
    current,
  }),
  [FETCH_ARTICLE_PAGE]: state => ({
    ...state,
    isFetchingArticles: true,
  }),
  [RECEIVED_ARTICLE_PAGE]: (state, { page, articles }) => ({
    ...state,
    articlePages: assoc(page, articles, state.articlePages),
    isFetchingArticles: false,
  }),
  [REMOVE_ARTICLE_PAGE]: (state, { page }) => ({
    ...state,
    articlePages: dissoc(page, state.articlePages),
  }),
  [ERROR]: (state, { error }) => ({
    ...state,
    isFetching: false,
    error,
  }),
  [CLEAN]: always(INITIAL_STATE),
})
